const TextareaAutoResizePort = {
  add: function (app) {
    const elements = new Map();

    const getMaxHeight = () => {
      const viewportHeight = window.visualViewport?.height || window.innerHeight;
      return Math.min(viewportHeight * 0.4, 300);
    };

    const resizeTextarea = (element) => {
      element.style.height = "auto";
      const scrollHeight = element.scrollHeight;
      const maxHeight = getMaxHeight();
      element.style.height = Math.min(scrollHeight, maxHeight) + "px";
      element.style.overflowY = scrollHeight > maxHeight ? "auto" : "hidden";
    };

    const setupElement = (elementId) => {
      if (elements.has(elementId)) {
        return;
      }

      const element = document.getElementById(elementId);
      if (!element) {
        return;
      }

      const handleResize = () => {
        resizeTextarea(element);
      };

      element.addEventListener("input", handleResize);
      window.addEventListener("resize", handleResize);

      const visualViewport = window.visualViewport;
      if (visualViewport) {
        visualViewport.addEventListener("resize", handleResize);
      }

      elements.set(elementId, { element, handleResize });
      resizeTextarea(element);
    };

    app.ports.autoResize.subscribe(function (elementId) {
      setupElement(elementId);

      const elementData = elements.get(elementId);
      if (elementData) {
        setTimeout(() => resizeTextarea(elementData.element), 0);
      }
    });
  },
};

module.exports = TextareaAutoResizePort;
